export default __webpack_public_path__ + "static/media/bestsellers.450f50a0.png";